import { render, staticRenderFns } from "./LoggedOutHomepage.vue?vue&type=template&id=0647fbe6&scoped=true&"
import script from "./LoggedOutHomepage.vue?vue&type=script&lang=ts&"
export * from "./LoggedOutHomepage.vue?vue&type=script&lang=ts&"
import style0 from "./LoggedOutHomepage.vue?vue&type=style&index=0&id=0647fbe6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0647fbe6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('0647fbe6', component.options)
    } else {
      api.reload('0647fbe6', component.options)
    }
    module.hot.accept("./LoggedOutHomepage.vue?vue&type=template&id=0647fbe6&scoped=true&", function () {
      api.rerender('0647fbe6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/index/LoggedOutHomepage.vue"
export default component.exports